import React, { useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { IoIosNotificationsOutline } from "react-icons/io";
import { set_global_notifications } from "../../redux/slices/globalNotificationsSlice";
import { GlobalSocketWrapperContext } from "../GlobalSocketWrapper";

const Notifications = () => {
  const dispatch = useDispatch();
  const sidebar = useSelector((state) => state.global_notifications.sidebar);
  const {unread_count, not_seen} = useSelector(state => state.global_notifications);
  const { sendMessage } = useContext(GlobalSocketWrapperContext);
  return (
    <>
      <button
        type="button"
        onClick={() => {
          sendMessage && sendMessage(JSON.stringify({ seen: true }))
          dispatch(set_global_notifications({
            sidebar: !sidebar,
            not_seen: 0,
          }))
        }

          }
        className={`relative flex items-center justify-center group h-10 w-10 bg-transparent rounded-lg hover:bg-primary`}
      >
        <IoIosNotificationsOutline className={`text-2xl group-hover:text-white`} />
        {
          not_seen > 0 &&
          <div className="absolute top-1 right-1 h-4 w-4 rounded-full bg-red-500 flex items-center justify-center">
          <p className="text-white text-[10px] font-semibold">
            {not_seen>=9? "9+": not_seen}
          </p>
        </div>
        }
      </button>
    </>
  );
};

export default Notifications;
